import { SET_POSTNUM } from "./types";

const mutations = {
  [SET_POSTNUM]: (state, num) => {
    state.postNum = num;
  },
};
export default mutations;
